<div class="wrapper">
  <h3 class="title">{{title}}</h3>
  <div class="text">
    <p *ngFor="let item of texts">
      {{item}}
    </p>
  </div>
</div>
